import { render, staticRenderFns } from "./CategoryPicker.vue?vue&type=template&id=38b2572e&"
import script from "./CategoryPicker.vue?vue&type=script&lang=js&"
export * from "./CategoryPicker.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports